<template>
  <div class="callact-main" :style="`padding-top:${barHeight}px`">
    <van-nav-bar class="van-bar" left-arrow @click-left="closeWeb">
      <template #left>
        <img class="left-nav" src="./images/c-left-arrow.png" alt="" />
      </template>
      <template #right>
        <span class="tit-right" @click="handleToRule">
          <img class="left-nav" src="./images/c-question.png" alt="" />
        </span>
      </template>
    </van-nav-bar>

    <!-- 头图 -->
    <div class="callact-head" :style="{ 'margin-top': `-${barHeight * 1 + 46}px` }">
      <img class="top-bg" src="./images/top-bg.png" />
      <img v-if="$i18n.locale == 'ar'" class="top-tit" :src="getMatchTitle('bg-ar')" />
      <img v-else-if="$i18n.locale == 'es'" class="top-tit" :src="getMatchTitle('bg-es')" />
      <img v-else-if="$i18n.locale == 'fr'" class="top-tit" :src="getMatchTitle('bg-fr')" />
      <img v-else-if="$i18n.locale == 'id'" class="top-tit" :src="getMatchTitle('bg-id')" />
      <img v-else-if="$i18n.locale == 'pt'" class="top-tit" :src="getMatchTitle('bg-pt')" />
      <img v-else-if="$i18n.locale == 'tr'" class="top-tit" :src="getMatchTitle('bg-tr')" />
      <img v-else class="top-tit" :src="getMatchTitle('bg-en')" />

      <template v-if="actInfo && actInfo.weekTask">
        <img v-if="actInfo.weekTask.state !== 2" class="top-box" :src="getMatchTitle('box-close')" />
        <img v-if="actInfo.weekTask.state === 2" class="top-box" :src="getMatchTitle('box-open')" />
      </template>
    </div>

    <div class="callact-con">
      <div class="callact-relcon">
        <!-- 倒计时 -->
        <div class="act-date-block">
          <!-- percent -->
          <div class="rect-bar-block">
            <div class="percent-block">
              <div v-if="actInfo" class="percent-bar">
                <div v-if="actInfo.percent > 0" class="percent-track" :style="{ width: `${actInfo.percent}%` }">
                  {{ actInfo.coins }}
                  <img :src="getMatchImg('coin')" alt="" />
                  <div v-if="actInfo.weekTask" class="max-tips">
                    <div v-if="actInfo.weekTask.state !== 2 && actInfo.coins === actInfo.max" class="max-tips-con1">
                      <span>{{ $t('lang.CallMotivation.k033') }}</span>
                      <img src="./images/rect-tips-mid.png" />
                    </div>
                    <div v-if="actInfo.weekTask.state === 2" class="max-tips-con2">
                      <span>{{ $t('lang.CallMotivation.k034') }}</span>
                      <img src="./images/rect-tips-long.png" />
                    </div>
                  </div>
                </div>
              </div>
              <div class="percent-gap"></div>
              <span v-if="actInfo" class="percent-num">
                {{ $t('lang.CallMotivation.k044') }}
                <i style="font-weight: 500">{{ actInfo.max }}</i>
              </span>
              <img class="key-icon" src="./images/key-icon.png" />
            </div>
            <div class="bar-tips">{{ $rt('lang.CallMotivation.k028') }}</div>
          </div>
          <!-- bg -->
          <img class="rect-bg" src="./images/rect-bg.png" />
          <!-- date -->
          <div class="date-block">
            <div class="end-txt">{{ $t('lang.ActCommon.k011') }}</div>
            <div class="date-con">
              <div class="date-item">
                <span>{{ countdownResult.days || '00' }}</span>
                <span>{{ $t('lang.CallMotivation.k045') }}</span>
              </div>
              <div class="date-step"></div>
              <div class="date-item">
                <span>{{ countdownResult.hours || '00' }}</span>
                <span>{{ $t('lang.CallMotivation.k001') }}</span>
              </div>
              <div class="date-step"></div>
              <div class="date-item">
                <span>{{ countdownResult.minutes || '00' }}</span>
                <span>{{ $t('lang.CallMotivation.k002') }}</span>
              </div>
              <div class="date-step"></div>
              <div class="date-item">
                <span>{{ countdownResult.seconds || '00' }}</span>
                <span>{{ $t('lang.CallMotivation.k003') }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Daily Tasks -->
        <div class="part-block">
          <div class="part-head part-head1">{{ $t('lang.ActCommon.k094') }}</div>
          <div class="part-tips">{{ $rt('lang.CallMotivation.k004') }}</div>
          <div v-if="actInfo && actInfo.signTask" class="task-item">
            <img class="task-icon" src="./images/date.png" />
            <div class="gap-ele"></div>
            <div class="task-txt">
              <div>{{ $t('lang.ActCommon.k047') }} ({{ actInfo.signTask.proc }}/{{ actInfo.signTask.target }})</div>
              <div class="ar-num">
                <img :src="getMatchImg('coin')" />
                +3 {{ $t('lang.CallMotivation.k005') }}
              </div>
            </div>
            <div v-if="actInfo.signTask.state == 0" class="task-btn active" @click="handleSign">{{ $t('lang.ActCommon.k095') }}</div>
            <div v-if="actInfo.signTask.state == 1" class="task-btn">
              <template v-if="leftClassObj && leftClassObj.countdownResult">
                {{ leftClassObj.countdownResult.hours }}:{{ leftClassObj.countdownResult.minutes }}:{{ leftClassObj.countdownResult.seconds }}
              </template>
              <template v-else>00:00:00</template>
            </div>
          </div>

          <div v-if="actInfo && actInfo.callTask" class="task-item">
            <img class="task-icon" src="./images/call.png" />
            <div class="gap-ele"></div>
            <div class="task-txt">
              <div>{{ $t('lang.CallMotivation.k006') }} ({{ actInfo.callTask.proc }}/{{ actInfo.callTask.target }})</div>
              <div class="ar-num">
                <img :src="getMatchImg('coin')" />
                +10 {{ $t('lang.CallMotivation.k005') }}
              </div>
            </div>
            <div v-if="actInfo.callTask.state == 0" class="task-btn active" @click="handleToClient">{{ $t('lang.ActCommon.k048') }}</div>
            <div v-if="actInfo.callTask.state == 1" class="task-btn">
              <template v-if="leftClassObj && leftClassObj.countdownResult">
                {{ leftClassObj.countdownResult.hours }}:{{ leftClassObj.countdownResult.minutes }}:{{ leftClassObj.countdownResult.seconds }}
              </template>
              <template v-else>00:00:00</template>
            </div>
          </div>
        </div>

        <!-- Repeatable Tasks -->
        <div class="part-block">
          <div class="part-head part-head1">{{ $t('lang.CallMotivation.k007') }}</div>
          <div v-if="actInfo && actInfo.unit === 1" class="part-tips">{{ $rt('lang.CallMotivation.k035') }}</div>
          <div v-else class="part-tips">{{ $rt('lang.CallMotivation.k008') }}</div>

          <div v-if="actInfo" class="task-card">
            <div class="card-item">
              <div class="card-item-count">
                {{ actInfo.calls }}
                <div style="width: 4px"></div>
                <i>{{ $t('lang.CallMotivation.k046') }}</i>
              </div>
              <div v-if="actInfo && actInfo.unit === 1" class="card-item-txt">{{ $t('lang.CallMotivation.k036') }}</div>
              <div v-else class="card-item-txt">{{ $t('lang.CallMotivation.k009') }}</div>
            </div>
            <div style="width: 12px"></div>
            <div class="card-item">
              <div class="card-item-count">
                {{ actInfo.refunded }}
                <div style="width: 4px"></div>
                <img :src="getMatchImg('coin')" />
              </div>
              <div class="card-item-txt">{{ $t('lang.CallMotivation.k010') }}</div>
            </div>
          </div>

          <div class="task-item">
            <img class="task-icon" src="./images/camera.png" />
            <div class="gap-ele"></div>
            <div class="task-txt">
              <div v-if="actInfo && actInfo.unit === 1">{{ $t('lang.CallMotivation.k037') }}</div>
              <div v-else>{{ $t('lang.CallMotivation.k011') }}</div>
              <div class="ar-num">
                <img :src="getMatchImg('coin')" />
                +10% {{ $t('lang.CallMotivation.k031') }}
              </div>
            </div>
            <template v-if="actInfo && actInfo.weekTask">
              <div v-if="actInfo.weekTask.state !== 2" class="task-btn active" @click="handleToClient">{{ $t('lang.ActCommon.k048') }}</div>
              <div v-else class="task-btn">{{ $t('lang.ActCommon.k087') }}</div>
            </template>
          </div>
        </div>

        <!-- Get the key -->
        <div class="part-block">
          <div class="part-head part-head2">{{ $t('lang.CallMotivation.k012') }}</div>

          <div v-if="actInfo && actInfo.unit === 1" class="part-tips">{{ $t('lang.CallMotivation.k042') }}</div>
          <div v-else class="part-tips">{{ $t('lang.CallMotivation.k013') }}</div>

          <div class="get-key-block">
            <div class="key-bar">
              <img class="key-clock" src="./images/clock.png" />
              <div class="key-bar-bg">
                <div v-if="actInfo && actInfo.weekTask" class="key-percent">
                  <div v-if="actInfo.weekTask.percent > 0" class="key-track" :style="{ width: `${actInfo.weekTask.percent}%` }">
                    <div class="key-track-tips">
                      <div>
                        <img src="./images/rect-tips.png" />
                        <span>
                          {{ actInfo.weekTask.proc }}
                          <i v-if="actInfo && actInfo.unit === 1">{{ $t('lang.ActCommon.k062') }}</i>
                          <i v-else>{{ $t('lang.CallMotivation.k043') }}</i>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <img class="key-right" src="./images/key-r.png" />
            </div>
            <div v-if="actInfo && actInfo.weekTask" class="key-tips">
              <div class="tips-left">
                {{ $t('lang.CallMotivation.k014') }}:
                <i>{{ actInfo.weekTask.target || 0 }}</i>
                <i v-if="actInfo && actInfo.unit === 1">dtk</i>
                <i v-else>{{ $t('lang.CallMotivation.k043') }}</i>
              </div>
              <div class="tips-right">
                {{ $t('lang.ActCommon.k001') }}:
                <i>{{ actInfo.weekTask.left || 0 }}</i>
                <i v-if="actInfo && actInfo.unit === 1">dtk</i>
                <i v-else>{{ $t('lang.CallMotivation.k043') }}</i>
              </div>
            </div>
            <div class="get-key-tips">
              <img src="./images/tips.png" />
              <span v-if="actInfo && actInfo.unit === 1">{{ $t('lang.CallMotivation.k039') }}</span>
              <span v-else>{{ $t('lang.CallMotivation.k032') }}</span>
            </div>
          </div>
        </div>

        <!-- btns -->
        <div v-if="actInfo && actInfo.weekTask" class="callact-btn-block">
          <div v-if="actInfo.weekTask.state === 0" class="callact-btn">{{ $t('lang.CallMotivation.k029') }}</div>
          <div v-if="actInfo.weekTask.state === 1" class="callact-btn callact-btn-active" @click="handleClaim">{{ $rt('lang.CallMotivation.k030') }}</div>
          <div v-if="actInfo.weekTask.state === 2" class="callact-btn">{{ $t('lang.ActCommon.k087') }}</div>

          <div :style="{ height: `${bottomBarHeight}px` }"></div>
        </div>
      </div>

      <div v-if="showSuccess" class="act-mask">
        <div class="dia-con">
          <img :src="getMatchImg('many-coins')" />
          <div class="dia-main">
            <div class="dia-tit">
              <div class="dia-tit-left"></div>
              <div class="dia-tit-txt">{{ $t('lang.ActCommon.k089') }}</div>
              <div class="dia-tit-right"></div>
            </div>
            <div class="dia-txt">
              <img src="./images/X.png" />
              {{ rewardCoins }}
            </div>
            <div class="dia-btn" @click="showSuccess = false">{{ $t('lang.ActCommon.k100') }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getCallMotivationCfg, signCallMotivation, claimCallMotivation } from './apidir/api.js'

import countDown from '@/mixin/count-down.js'
import CountDownClass from '@/utils/count-down.js'

import bgArVava from './images/vava/bg-ar.png'
import bgEnVava from './images/vava/bg-en.png'
import bgEsVava from './images/vava/bg-es.png'
import bgFrVava from './images/vava/bg-fr.png'
import bgIdVava from './images/vava/bg-id.png'
import bgPtVava from './images/vava/bg-pt.png'
import bgTrVava from './images/vava/bg-tr.png'
import boxOpenVava from './images/vava/box-open.png'
import boxCloseVava from './images/vava/box-close.png'

import bgArEcho from './images/echo/bg-ar.png'
import bgEnEcho from './images/echo/bg-en.png'
import bgEsEcho from './images/echo/bg-es.png'
import bgFrEcho from './images/echo/bg-fr.png'
import bgIdEcho from './images/echo/bg-id.png'
import bgPtEcho from './images/echo/bg-pt.png'
import bgTrEcho from './images/echo/bg-tr.png'
import boxOpenEcho from './images/echo/box-open.png'
import boxCloseEcho from './images/echo/box-close.png'

export default {
  mixins: [countDown],
  data() {
    return {
      bottomBarHeight: 0,
      actInfo: null,
      showSuccess: false,
      rewardCoins: 0,
      // 当天倒计时相关
      leftClassObj: null
    }
  },
  methods: {
    getMatchTitle(imgname) {
      const imgsMap = {
        'bg-ar': {
          vava: bgArVava,
          echo: bgArEcho,
          joychat: bgArVava
        },
        'bg-en': {
          vava: bgEnVava,
          echo: bgEnEcho,
          joychat: bgEnVava
        },
        'bg-es': {
          vava: bgEsVava,
          echo: bgEsEcho,
          joychat: bgEsVava
        },
        'bg-fr': {
          vava: bgFrVava,
          echo: bgFrEcho,
          joychat: bgFrVava
        },
        'bg-id': {
          vava: bgIdVava,
          echo: bgIdEcho,
          joychat: bgIdVava
        },
        'bg-pt': {
          vava: bgPtVava,
          echo: bgPtEcho,
          joychat: bgPtVava
        },
        'bg-tr': {
          vava: bgTrVava,
          echo: bgTrEcho,
          joychat: bgTrVava
        },
        'box-open': {
          vava: boxOpenVava,
          echo: boxOpenEcho,
          joychat: boxOpenVava
        },
        'box-close': {
          vava: boxCloseVava,
          echo: boxCloseEcho,
          joychat: boxCloseVava
        }
      }

      // 按包名判断
      const appName = this.getAppName()
      if (this.appNameFlag('vava', appName)) {
        return imgsMap[imgname]['vava']
      }
      if (this.appNameFlag('echo', appName)) {
        return imgsMap[imgname]['echo']
      }
      if (this.appNameFlag('joychat', appName)) {
        return imgsMap[imgname]['joychat']
      }
      if (this.appNameFlag('joylink', appName)) {
        return imgsMap[imgname]['joylink']
      }
      if (this.appNameFlag('goparty', appName)) {
        return imgsMap[imgname]['goparty']
      }
    },
    handleToRule() {
      this.$router.push({ path: '/call-motivation-rules', query: { from: 'call-motivation', unit: this.actInfo.unit } })
    },
    handleToClient() {
      // 数数-付费通话时长激励活动
      this.traceAction({ Action: 'Click', APosition: 'Button', AValue: 'call-motivation_open_session_page' })

      this.appAction('open_session_page')
    },
    handleSign() {
      signCallMotivation().then((resData) => {
        if (resData) {
          this.fetchData()

          // 数数-付费通话时长激励活动
          this.traceAction({ Action: 'Click', APosition: 'Button', AValue: 'call-motivation_sign' })
        }
      })
    },
    handleClaim() {
      claimCallMotivation().then((resData) => {
        if (resData) {
          this.rewardCoins = resData.coins || 0
          this.showSuccess = true
          this.fetchData()

          // 数数-付费通话时长激励活动
          this.traceAction({ Action: 'Click', APosition: 'Button', AValue: 'call-motivation_claim' })
        }
      })
    },
    // 获取数据
    fetchData() {
      getCallMotivationCfg().then((resData) => {
        if (resData) {
          if (resData.max) {
            resData.percent = Math.max(Math.floor((resData.coins / resData.max) * 100), 15)
          }
          if (resData.weekCountdown) {
            this.initCountDown(resData.weekCountdown, true)
          }

          if (resData.dayCountdown) {
            this.leftClassObj = new CountDownClass()
            this.leftClassObj.initCountDown(resData.dayCountdown, 'HMS')
          }

          if (resData.weekTask && resData.weekTask.target) {
            let tempPercent = Math.floor((resData.weekTask.proc / resData.weekTask.target) * 100)
            if (tempPercent > 100) {
              tempPercent = 100
            }
            resData.weekTask.percent = tempPercent

            let tempLeft = resData.weekTask.target - resData.weekTask.proc
            if (tempLeft < 0) {
              tempLeft = 0
            }
            resData.weekTask.left = tempLeft
          }
          this.actInfo = resData
        }
      })
    }
  },
  created() {
    this.fetchData()
    // 数数-付费通话时长激励活动
    this.traceAction({ Action: 'Click', APosition: 'entrance', AValue: 'call-motivation' })
  }
}
</script>

<style lang="scss" scoped>
.callact-main {
  width: 100%;
  min-height: 100vh;

  .van-bar {
    z-index: 99;
    .left-nav {
      width: 32px;
      height: 32px;
    }
  }

  .callact-head {
    position: relative;
    .top-bg {
      width: 100%;
    }

    .top-tit {
      width: 100%;
      position: absolute;
      top: 55px;
      left: 0;
      z-index: 10;
    }

    .top-box {
      width: 100%;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 9;
    }
  }

  .callact-con {
    min-height: 500px;
    background-color: #df015d;
    margin-top: -105px;
    padding-bottom: 100px;

    .callact-relcon {
      width: 100%;
      height: 100%;
      padding: 0 16px 60px;
      position: relative;
      z-index: 9;

      .act-date-block {
        width: 343px;
        padding-top: 22px;
        position: relative;
        .rect-bar-block {
          width: 323px;
          height: 129px;
          border-radius: 14px;
          position: absolute;
          top: 0;
          right: 0;
          background-image: linear-gradient(180deg, rgba(255, 255, 255, 0.7) 0%, rgba(255, 255, 255, 0) 100%);

          .percent-block {
            display: flex;
            justify-content: flex-start;
            padding-top: 8px;
            padding-right: 20px;
            margin-left: 59px;
            position: relative;
            .percent-bar {
              box-sizing: border-box;
              flex: 1;
              height: 18px;
              border-radius: 18px;
              background-color: #76001a;
              border: 1px solid #ff712a;
              position: relative;
              overflow: visible;
              .percent-track {
                width: 15%;
                height: 16px;
                padding: 5px;
                border-radius: 16px;
                background: url(./images/percent-bg.png) center center / auto 100% repeat;

                display: flex;
                align-items: center;
                justify-content: flex-end;

                color: #ffffff;
                font-family: 'Oswald-Regular';
                font-size: 12px;
                font-weight: 400;

                img {
                  width: 12px;
                  height: 12px;
                }
              }
              .max-tips {
                width: calc(100vw - 48px);
                position: absolute;
                top: -44px;
                right: -48px;

                color: #fff;
                font-family: 'Oswald-Regular';
                font-size: 12px;
                font-weight: 400;
                display: flex;
                justify-content: flex-end;

                .max-tips-con1,
                .max-tips-con2 {
                  height: 44px;
                  width: fit-content;
                  padding: 9px 20px;
                  display: flex;
                  position: relative;
                  span {
                    display: inline-block;
                    line-height: 18px;
                    width: fit-content;
                    position: relative;
                    z-index: 3;
                  }
                  img {
                    width: 100%;
                    height: 100%;
                    position: absolute;
                    top: 0;
                    left: 0;
                  }
                }
              }
            }
            .percent-gap {
              width: 10px;
            }
            .percent-num {
              color: #970022;
              font-family: 'Oswald-Regular';
              font-size: 12px;
              font-weight: 400;
              line-height: normal;
            }

            .key-icon {
              width: 36px;
              height: 21px;
              position: absolute;
              left: 200px;
              top: 26px;
            }
          }

          .bar-tips {
            color: #805d65;
            font-family: 'Oswald-Regular';
            font-size: 9px;
            font-weight: 400;
            margin-top: 3px;
            margin-left: 59px;
          }
        }
        .rect-bg {
          width: 335px;
        }
        .date-block {
          width: 100%;
          position: absolute;
          top: 22px;
          left: 0;

          .end-txt {
            color: #40000f;
            font-family: 'Oswald-Regular';
            font-size: 16px;
            font-weight: 500;
            padding: 4px 12px;
          }

          .date-con {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-around;
            padding: 0 11px;
            margin-top: 13px;
            .date-item {
              display: flex;
              flex-direction: column;
              text-align: center;
              justify-content: flex-end;

              width: 48px;
              height: 68px;
              padding-bottom: 2px;
              border-radius: 8px;
              background: rgba(255, 35, 85, 0.1);

              span {
                &:first-child {
                  color: #40000f;
                  text-align: center;
                  font-family: 'BebasNeue-Regular';
                  font-size: 43px;
                  line-height: 43px;
                  font-weight: 400;
                }

                &:last-child {
                  color: #ff92ab;
                  text-align: center;
                  font-family: 'Oswald-Regular';
                  font-size: 11px;
                  line-height: 11px;
                  min-height: 11px;
                  font-style: normal;
                  font-weight: 400;
                  line-height: normal;
                }
              }
            }
            .date-step {
              width: 6px;
              height: 68px;
              position: relative;
              &::before {
                width: 6px;
                height: 6px;
                border-radius: 6px;
                background-color: #40000f;
                content: '';
                position: absolute;
                top: 40%;
                left: 0;
                margin-top: -6px;
              }

              &::after {
                width: 6px;
                height: 6px;
                border-radius: 6px;
                background-color: #40000f;
                content: '';
                position: absolute;
                top: 40%;
                left: 0;
                margin-top: 6px;
              }
            }
          }
        }
      }

      .part-block {
        width: 343px;
        padding-bottom: 16px;
        margin-top: 16px;
        border-radius: 16px;
        background: #fff;
        .part-head {
          color: #40000f;
          font-family: 'Oswald-Regular';
          font-size: 20px;
          font-weight: 700;
          padding: 12px 12px 0;
          border-radius: 16px 16px 0 0;
          border: 1px solid #fff;
        }
        .part-head1 {
          background: linear-gradient(180deg, #ffd9e4 0%, rgba(255, 217, 228, 0) 100%);
        }
        .part-head2 {
          background: linear-gradient(180deg, #fff0d9 0%, rgba(255, 240, 217, 0) 100%);
        }
        .part-tips {
          color: #805d65;
          font-family: 'Oswald-Regular';
          font-size: 12px;
          font-weight: 400;
          padding: 0 12px;
        }
      }

      .task-item {
        margin-top: 12px;
        padding: 0 12px;
        display: flex;
        align-items: center;

        .task-icon {
          width: 44px;
          height: 44px;
        }
        .gap-ele {
          width: 12px;
        }
        .task-txt {
          flex: 1;
          > div {
            &:first-of-type {
              color: #40000f;
              font-family: 'Oswald-Regular';
              font-size: 14px;
              font-weight: 500;
            }
            &:last-of-type {
              color: #e99b4c;
              font-family: 'Oswald-Regular';
              font-size: 12px;
              font-weight: 500;

              img {
                width: 12px;
                height: 12px;
              }
            }
          }
        }
        .task-btn {
          display: flex;
          width: 88px;
          padding: 8px 20px;
          justify-content: center;
          align-items: center;
          border-radius: 100px;
          background: #ccc;

          color: #fff;
          font-family: 'Oswald-Regular';
          font-size: 12px;
          font-weight: 500;
        }
        .task-btn.active {
          background: #ff4982;
        }
      }

      .task-card {
        display: flex;
        align-items: center;
        margin: 12px 12px 24px;
        .card-item {
          padding: 12px;
          flex: 1;
          border-radius: 8px;
          background: linear-gradient(180deg, #fff0dd 0%, rgba(255, 240, 221, 0.1) 100%);

          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          .card-item-count {
            color: #40000f;
            font-family: 'Oswald-Regular';
            font-size: 20px;
            font-weight: 600;
            display: flex;
            align-items: center;
            i {
              font-size: 12px;
              font-weight: normal;
              margin-top: 6px;
            }
            img {
              width: 16px;
              height: 16px;
            }
          }
          .card-item-txt {
            color: #805d65;
            font-family: 'Oswald-Regular';
            font-size: 9px;
            font-weight: 400;
          }
        }
      }

      .get-key-block {
        padding: 46px 15px 0;
        .key-bar {
          position: relative;
          height: 28px;
          padding-left: 10px;
          display: flex;
          align-items: center;
          .key-clock {
            width: 28px;
            height: 28px;
            position: absolute;
            top: 0;
            left: -5px;
          }
          .key-bar-bg {
            width: 302px;
            height: 16px;
            padding: 0 31px 0 20px;
            background: linear-gradient(90deg, #e8f7ff 0%, #ffe7de 100%);
            display: flex;
            align-items: center;

            .key-percent {
              display: flex;
              width: 100%;
              height: 12px;
              border-radius: 12px;
              background: rgba(255, 255, 255, 0.7);
              .key-track {
                width: 0;
                height: 100%;
                border-radius: 12px;
                background: linear-gradient(90deg, #ffd280 0%, #f62b40 100%);
                position: relative;
                overflow: visible;
                .key-track-tips {
                  position: absolute;
                  top: -36px;
                  right: -15px;
                  // width: 52px;
                  height: 30px;
                  div {
                    // width: 72px;
                    height: 30px;
                    position: relative;
                    img {
                      width: 100%;
                      height: 30px;
                      position: relative;
                      z-index: 0;
                    }
                    span {
                      position: absolute;
                      left: 8px;
                      z-index: 1;
                      color: #fff;
                      font-family: 'Oswald-Regular';
                      font-size: 16px;
                      font-weight: 600;
                      i {
                        color: #fff;
                        font-family: 'Oswald-Regular';
                        font-size: 12px;
                      }
                    }
                  }
                }
              }
            }
          }
          .key-right {
            width: 31px;
            height: 28px;
            position: absolute;
            top: 0;
            right: 0;
          }
        }
        .key-tips {
          margin-top: 6px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          .tips-left {
            color: #805d65;
            font-family: 'Oswald-Regular';
            font-size: 12px;
            font-weight: 400;
            i {
              &:first-of-type {
                color: #805d65;
                font-weight: bold;
              }
              &:last-of-type {
                color: #b5a0a5;
              }
            }
          }
          .tips-right {
            color: #805d65;
            font-family: 'Oswald-Regular';
            font-size: 12px;
            font-weight: 400;
            i {
              &:first-of-type {
                color: #e61d75;
                font-weight: bold;
              }
              &:last-of-type {
                color: #df90b3;
              }
            }
          }
        }
        .get-key-tips {
          margin-top: 13px;
          color: #b5a0a5;
          font-family: 'Oswald-Regular';
          font-size: 10px;
          img {
            width: 12px;
            height: 12px;
            vertical-align: middle;
          }
          span {
            display: inline-block;
            vertical-align: middle;
            margin: 0 4px;
          }
        }
      }

      .callact-btn-block {
        position: fixed;
        bottom: 0;
        left: 0;
        z-index: 99;
        width: 100%;
        padding-bottom: 25px;
        .callact-btn {
          width: 343px;
          line-height: 56px;
          margin: 16px auto 0;
          border-radius: 100px;
          color: #fff;
          text-align: center;
          font-family: 'Anton-Regular';
          font-size: 20px;
          font-weight: 400;
          background: url(./images/btn-bg-gray.png) center center / 100% 100% no-repeat;
        }
        .callact-btn-active {
          background: url(./images/btn-bg-colorful.png) center center / 100% 100% no-repeat;
        }
      }
    }
  }
}

.act-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;

  .dia-con {
    width: 235px;
    min-height: 246px;
    background: url(./images/dia-bg.png) center center / 100% 100% no-repeat;
    img {
      width: 100%;
      margin-top: -49px;
    }
    .dia-main {
      .dia-tit {
        width: 100%;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        .dia-tit-left {
          width: 28px;
          height: 2px;
          background: linear-gradient(90deg, rgba(64, 0, 15, 0) 0%, #40000f 100%);
        }
        .dia-tit-txt {
          color: #40000f;
          font-family: 'AntonSC-Regular';
          font-size: 20px;
          line-height: 20px;
          margin: 0 9px;
        }
        .dia-tit-right {
          width: 28px;
          height: 2px;
          background: linear-gradient(90deg, #40000f 0, rgba(64, 0, 15, 0) 100%);
        }
      }
      .dia-txt {
        margin: 12px;
        padding: 12px 0;
        color: #ff7515;
        text-align: center;
        font-family: 'BebasNeue-Regular';
        font-size: 48px;
        line-height: 48px;
        background: url(./images/dia-bg2.png) center center / 100% 100% no-repeat;
        img {
          width: 12px;
          height: 17px;
        }
      }
      .dia-btn {
        display: flex;
        width: 203px;
        margin: 16px auto;
        padding: 13px 74px;
        justify-content: center;
        align-items: center;
        border-radius: 100px;
        background: linear-gradient(106deg, #ffaa47 10.39%, #ff2886 99.71%);

        color: #fff;
        text-align: center;
        font-family: 'Anton-Regular';
        font-size: 24px;
        line-height: 24px;
      }
    }
  }
}

html[lang='ar'],
html[lang='fa'],
html[lang='he'] {
  .callact-main {
    .callact-con {
      .callact-relcon {
        .act-date-block {
          .rect-bar-block {
            left: 0;
            right: unset;
            .percent-block {
              margin-right: 59px;
              margin-left: unset;
              padding-left: 20px;
              padding-right: unset;
              justify-content: flex-end;

              .percent-bar {
                .max-tips {
                  right: unset;
                  left: -48px;

                  .max-tips-con1,
                  .max-tips-con2 {
                    img {
                      transform: rotateY(180deg);
                    }
                  }
                }
              }

              .key-icon {
                left: unset;
                right: 200px;
              }
            }

            .bar-tips {
              margin-left: unset;
              margin-right: 59px;
            }
          }
        }
        .rect-bg {
          transform: rotateY(180deg);
        }

        .get-key-block {
          .key-bar {
            padding-right: 10px;
            padding-left: unset;
            .key-clock {
              right: -5px;
              left: unset;
            }
            .key-bar-bg {
              padding: 0 20px 0 31px;

              .key-percent {
                .key-track {
                  .key-track-tips {
                    left: -5px;
                    right: unset;
                    div {
                      // width: 80px;
                      height: 30px;
                      position: relative;
                      img {
                        width: 100%;
                        height: 30px;
                        position: relative;
                        z-index: 0;
                        transform: rotateY(180deg);
                      }
                      span {
                        left: unset;
                        right: 8px;
                        overflow: hidden;
                      }
                    }
                  }
                }
              }
            }
            .key-right {
              top: 0;
              left: 0;
              right: unset;
              transform: rotateY(180deg);
            }
          }
        }
      }
      .ar-num {
        img {
          margin-left: 2px;
        }
      }
    }
  }
}
</style>
